import { Navigate, Outlet, useLocation } from "react-router";
import Footer from "./footer";
import Header from "./header";
import SubscribeSection from "../common/components/pages/subscribe-section";
import { routes } from "../routes";

const Layout = () => {
  const location = useLocation();
  const pathname = location?.pathname?.replace("/", "");

  if (pathname === "payment") {
    if (localStorage.getItem("accessPaymentRoutes")) {
      return <Outlet />;
    } else {
      return <Navigate to={routes.HOME} />;
    }
  }

  return (
    <>
      <Header state={location?.state} />
      <main>
        <Outlet />
        {!pathname.includes("be-an-advisor") && <SubscribeSection />}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
